
<template>
  <div class="wrapper" >
    <div v-for="(item, i) in titles" :style="{'flex-basis': 100 / titles.length + 'vw'}" @click="handleClick(i)" :key="i" class="tab-item" :class="i === value ? 'active-item' : ''">
      {{item}}
      <div v-if="i === value" class="bottom-line" ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titles: Array,
    defaultValue: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      value: undefined
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  methods: {
    handleClick (i) {
      if (this.value !== i) {
        this.value = i
        this.$emit('change', i)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../css/var'
  .wrapper
    background-color white
    depth(1)
    height pt(100)
    display flex
    justify-content center
    align-items center
    border-bottom 1px solid $divide-line-color
    .tab-item
      text-align center
      font-size $normal-font-size
      color $normal-text-color
      position relative
      line-height pt(100)
      white-space nowrap
      .bottom-line
        position absolute
        height 2px
        width 100%
        bottom 0px
        left 0
        background-color $primary-color
    .active-item
      color $primary-color
</style>



// WEBPACK FOOTER //
// top-tab.vue?97b01d44